
import { Calendar, MapPin } from "lucide-react";
import { format } from "date-fns";

interface EventMetadataProps {
  date: string | null;
  location: string;
  status: string;
  description?: string;
  locationType?: 'specific' | 'flexible';
  flexibleLocationDescription?: string;
  preferredDates?: Date[];
  preferredVenues?: string[];
}

export const EventMetadata = ({
  date,
  location,
  status,
  description,
  locationType = 'specific',
  flexibleLocationDescription,
  preferredDates = [],
  preferredVenues = [],
}: EventMetadataProps) => {
  const isConfirmed = status === 'confirmed' || status === 'booked';
  
  // Return null if there's no content to display
  if (!description && !isConfirmed) {
    return null;
  }

  const formatDate = (dateString: string | null) => {
    // For confirmed/booked events with a selected date
    if (!dateString) return 'Date TBD';
    try {
      return format(new Date(dateString), 'PPP');
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Invalid date';
    }
  };

  const formatLocation = (loc: string) => {
    // For confirmed/booked events with a selected venue
    return loc || 'Location TBD';
  };

  return (
    <div className="space-y-2">
      {description && (
        <p className="text-sm text-gray-700">{description}</p>
      )}
      
      {isConfirmed && (
        <>
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Calendar className="w-4 h-4" />
            <p>{formatDate(date)}</p>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <MapPin className="w-4 h-4" />
            <p>{formatLocation(location)}</p>
          </div>
        </>
      )}
    </div>
  );
};
